
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import { weekdays } from '@/types/time'

const WeekdaySelect = Vue.extend({
    inheritAttrs: false,
    mixins: [AppMixin],
    props: {
        value: {
            type: String,
            required: false,
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },

    data() {
        return {
            weekdays: weekdays,
            content: this.value,
        }
    },
})

export default WeekdaySelect
